var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      staticClass: "draw-attr-wrapper",
      attrs: {
        "append-to-body": false,
        title: _vm.$t("product-manager::prop::table_prop"),
        visible: _vm.show,
        wrapperClosable: false,
        "custom-class": "attr-drawer",
        direction: "rtl",
        size: "550px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
        close: _vm.onChange,
      },
    },
    [
      _c(
        "el-row",
        { staticStyle: { padding: "0 24px" }, attrs: { gutter: 15 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 24 } },
            [
              _c(
                "el-form",
                {
                  ref: "dynamicValidateForm",
                  attrs: { model: _vm.form },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-table",
                    { attrs: { data: _vm.form.items, loading: _vm.loading } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "product-manager::prop_value::table_no"
                          ),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var $index = ref.$index
                              return [
                                _c(
                                  "div",
                                  { staticClass: "prodinfo--table__imgTd" },
                                  [
                                    _c("div", [
                                      _c("div", [_vm._v(_vm._s($index + 1))]),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "product-manager::prop_value::table_name"
                          ),
                          prop: "name",
                          width: "130",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              var $index = ref.$index
                              return [
                                row.isEdit == "save"
                                  ? _c(
                                      "el-form-item",
                                      {
                                        key: $index,
                                        staticClass: "cell-name",
                                        attrs: {
                                          prop: "items." + $index + ".name",
                                          rules: [
                                            {
                                              required: true,
                                              message: "",
                                              trigger: "change",
                                            },
                                          ],
                                          label: "",
                                          "label-width": "0",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            min: 0,
                                            placeholder: _vm.$t(
                                              "product-manager::prop_value::placeholder_name"
                                            ),
                                            size: "mini",
                                          },
                                          model: {
                                            value: row.name,
                                            callback: function ($$v) {
                                              _vm.$set(row, "name", $$v)
                                            },
                                            expression: "row.name",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _c("span", [
                                      _vm._v(_vm._s(_vm.$dataCheck(row.name))),
                                    ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "product-manager::prop_value::table_creatTime"
                          ),
                          prop: "createTime",
                          width: "165",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "div",
                                  { staticClass: "prodinfo--table__imgTd" },
                                  [
                                    _c("div", [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(_vm.$dataCheck(row.createTime))
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("product-manager::prop::table_handle"),
                          width: "130",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              var $index = ref.$index
                              return [
                                row.isEdit === "save"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          loading: row.loading,
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onBtnClick(
                                              "save",
                                              $index,
                                              row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("system::common::btn::save")
                                          )
                                        ),
                                      ]
                                    )
                                  : [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onBtnClick(
                                                "edit",
                                                $index,
                                                row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "product-manager::prop::table_edit"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onBtnClick(
                                                "del",
                                                $index,
                                                row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "product-manager::prop::table_delete"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.isAdd
            ? _c(
                "el-col",
                { staticClass: "mt-12", attrs: { lg: 24 } },
                [
                  _c("el-button", { on: { click: _vm.onAdd } }, [
                    _vm._v(
                      _vm._s(_vm.$t("product-manager::prop_value::add_button"))
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }